import { render, staticRenderFns } from "./ordersReport.vue?vue&type=template&id=4127d552&"
import script from "./ordersReport.vue?vue&type=script&lang=js&"
export * from "./ordersReport.vue?vue&type=script&lang=js&"
import style0 from "./ordersReport.vue?vue&type=style&index=0&id=4127d552&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports